import { render, staticRenderFns } from "./RemainingAgeChartComponent.vue?vue&type=template&id=754ded2c"
import script from "./RemainingAgeChartComponent.vue?vue&type=script&lang=js"
export * from "./RemainingAgeChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports